import { connectionData, endpoint } from "./apiConnection.js";
export const dataNotas = async id => connectionData(endpoint,'notas/'+id,'GET');
export const addNotas = async (alumno_id,body) => connectionData(endpoint,'notas/'+alumno_id,'POST',body);
export const deleteNota = async ( id ) => connectionData(endpoint,'notas/'+id,'DELETE');